<div class="priority-row">
  <div class="priority-row-content">
    <ng-container *ngIf="hasFirstColumn">
      <div class="priority-column">
        <div [class]="sectionClass"
             [style.border-color]="firstColumn.colorCode">
          <div class="priority-stack-section-header"
               [style.background-color]="firstColumn.colorCode">
            <h3>{{heading}}</h3>
          </div>
          <div [class]="sectionContentClass"
               [style.border-color]="firstColumn.colorCode">
            <app-edit-overlay [targetCoordinate]="targetCoordinate"
                              [isEditor]="!isEditItemDisabled"
                              (planCoordinateChange)="onPlanCoordinateChange($event)">
              <ul class="data-list">
                <li *ngFor="let rowX of firstColumn.dataRows">
                  <div>
                    <p>{{truncateContent(rowX) || ''}}</p>
                  </div>
                </li>
              </ul>
            </app-edit-overlay>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="hasSecondColumn">
      <div class="priority-column">
        <div [class]="sectionClass"
             [style.border-color]="secondColumn.colorCode">
          <div class="priority-stack-section-header"
               [style.background-color]="secondColumn.colorCode">
            <h3>{{heading}}</h3>
          </div>
          <div [class]="sectionContentClass"
               [style.border-color]="secondColumn.colorCode">
            <app-edit-overlay [targetCoordinate]="targetCoordinate"
                              [isEditor]="!isEditItemDisabled"
                              (planCoordinateChange)="onPlanCoordinateChange($event)">
              <ul class="data-list">
                <li *ngFor="let rowX of secondColumn.dataRows">
                  <div>
                    <p>{{truncateContent(rowX) || ''}}</p>
                  </div>
                </li>
              </ul>
            </app-edit-overlay>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="hasThirdColumn">
      <div class="priority-column">
        <div [class]="sectionClass"
             [style.border-color]="thirdColumn.colorCode">
          <div class="priority-stack-section-header"
               [style.background-color]="thirdColumn.colorCode">
            <h3>{{heading}}</h3>
          </div>
          <div [class]="sectionContentClass"
               [style.border-color]="thirdColumn.colorCode">
            <app-edit-overlay [targetCoordinate]="targetCoordinate"
                              [isEditor]="!isEditItemDisabled"
                              (planCoordinateChange)="onPlanCoordinateChange($event)">
              <ul class="data-list">
                <li *ngFor="let rowX of thirdColumn.dataRows">
                  <div>
                    <p>{{truncateContent(rowX) || ''}}</p>
                  </div>
                </li>
              </ul>
            </app-edit-overlay>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="needsPlaceholderColumn">
      <div class="priority-column placeholder"
           (click)="onClickPurposeMissionBeliefs()">
        <div [class]="sectionClass"
             [style.border-color]="placeholderColor">
          <div class="priority-stack-section-header"
               [style.background-color]="placeholderColor">
            <h3></h3>
          </div>
          <div [class]="sectionContentClass"
               [style.border-color]="placeholderColor">
            <ul>
              <li *ngFor="let placeholderRow of placeholderDataRows" (click)="onClickPurposeMissionBeliefs()">
                <p (click)="onClickPurposeMissionBeliefs()"></p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="needsFillerPlaceholderColumns">
      <div class="priority-column placeholder"
           (click)="onClickPurposeMissionBeliefs()">
        <div [class]="sectionClass"
             [style.border-color]="placeholderColor">
          <div class="priority-stack-section-header"
               [style.background-color]="placeholderColor">
            <h3></h3>
          </div>
          <div [class]="sectionContentClass"
               [style.border-color]="placeholderColor">
            <ul>
              <li *ngFor="let placeholderRow of placeholderDataRows" (click)="onClickPurposeMissionBeliefs()">
                <p (click)="onClickPurposeMissionBeliefs()"></p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="needsFillerPlaceholderColumns">
      <div class="priority-column placeholder"
           (click)="onClickPurposeMissionBeliefs()">
        <div [class]="sectionClass"
             [style.border-color]="placeholderColor">
          <div class="priority-stack-section-header"
               [style.background-color]="placeholderColor">
            <h3></h3>
          </div>
          <div [class]="sectionContentClass"
               [style.border-color]="placeholderColor">
            <ul>
              <li *ngFor="let placeholderRow of placeholderDataRows" (click)="onClickPurposeMissionBeliefs()">
                <p (click)="onClickPurposeMissionBeliefs()"></p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="needsInvisiColumn">
      <div class="priority-column invisible">
        <div [class]="sectionClass"
             [style.border-color]="transparent">
          <div class="priority-stack-section-header"
               [style.background-color]="transparent">
            <h3></h3>
          </div>
          <div [class]="sectionContentClass"
               [style.border-color]="transparent">
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="needsSecondInvisiColumn">
      <div class="priority-column invisible">
        <div [class]="sectionClass"
             [style.border-color]="transparent">
          <div class="priority-stack-section-header"
               [style.background-color]="transparent">
            <h3></h3>
          </div>
          <div [class]="sectionContentClass"
               [style.border-color]="transparent">
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
